import * as z from 'zod'

import {buildEntrySchemaFor} from '../entry'
import {safeOptional} from '../../safe-optional'
import {FormFieldValidationSchema} from './formFieldValidation'

export const FormFieldCheckboxGroupSchema = buildEntrySchemaFor('formFieldCheckboxGroup', {
  fields: z.lazy(() =>
    z.object({
      text: z.string(),
      htmlName: z.string(),
      options: z.looseObject({}).catchall(z.string()),
      validations: safeOptional(z.array(FormFieldValidationSchema)),
    }),
  ),
})

export type FormFieldCheckboxGroup = z.infer<typeof FormFieldCheckboxGroupSchema>

export const isFormFieldCheckboxGroup = (value: unknown): value is FormFieldCheckboxGroup => {
  return FormFieldCheckboxGroupSchema.safeParse(value).success
}
